import { Fragment, useState } from '@wordpress/element';

import {
	Modal,
	Button,
	withFilters,
	Icon,
	__experimentalVStack as VStack,
	__experimentalHStack as HStack,
	__experimentalConfirmDialog as ConfirmDialog,
} from '@wordpress/components';
import { useSelect } from '@wordpress/data';
import { useEntityProp } from '@wordpress/core-data';

import { applyFilters } from '@wordpress/hooks';
import { __, sprintf } from '@wordpress/i18n';
import { icons } from './constants';

function Confirm( { isOpen, onCancel, onConfirm, action } ) {
	return (
		<ConfirmDialog
			isOpen={ isOpen }
			onConfirm={ onConfirm }
			onCancel={ onCancel }
		>
			{ sprintf(
				/* translators: %s: action name */
				__( `Delete action %s?`, 'popper' ),
				action.name
			) }
		</ConfirmDialog>
	);
}

const Promo = withFilters( 'popper.modal.promo' )( ( props ) => {
	const free = [ 'Email', 'Subscribe' ];

	if ( free.includes( props.settings.name ) ) {
		return null;
	}

	return (
		<div>
			<p>
				{ __(
					'This action is available only for PRO users. You can try one month free.',
					'popper'
				) }
			</p>
			<Button
				variant="primary"
				href="https://formello.net"
				icon="download"
				iconPosition={ 'right' }
				target="_blank"
			>
				{ __( 'Try it now FREE!', 'popper' ) }
			</Button>
		</div>
	);
} );

export function ActionsModal( props ) {
	const { onRequestClose, settings, clientId, remove } = props;

	const [ action, setAction ] = useState( Object.assign( {}, settings ) );
	const [ isOpen, setIsOpen ] = useState( false );

	const updateSettings = ( prop, val ) => {
		setAction( { ...action, [ prop ]: val } );
	};

	const { postType, postId } = useSelect( ( select ) => {
		return {
			postType: select( 'core/editor' ).getCurrentPostType(),
			postId: select( 'core/editor' ).getCurrentPostId(),
		};
	}, [] );

	const [ meta, setMeta ] = useEntityProp(
		'postType',
		postType,
		'meta',
		postId
	);

	const save = ( item ) => {
		if ( ! item.id ) {
			const newItem = Object.assign( item, {
				id: meta._popper_actions.length + 1,
			} );
			setMeta( {
				_popper_actions: [ ...meta._popper_actions, newItem ],
			} );
		} else {
			const arr = meta._popper_actions.map( ( el ) =>
				el.id === item.id ? { ...el, ...item } : el
			);
			setMeta( { _popper_actions: arr } );
		}
		onRequestClose( false );
	};

	return (
		<Fragment>
			<Modal
				title={
					<HStack>
						<Icon icon={ icons[ settings.name ] } />
						<b>{ settings.name }</b>
					</HStack>
				}
				onRequestClose={ onRequestClose }
				shouldCloseOnClickOutside={ false }
				size={ 'medium' }
				className={ 'popper-modal' }
			>
				<VStack spacing={ 5 }>
					<Promo { ...props } />
					<Fragment>
						{ applyFilters(
							'popper.modal.' + settings.name,
							'',
							clientId,
							action,
							updateSettings
						) }

						<HStack>
							<Button
								isDestructive={ true }
								onClick={ () => {
									setIsOpen( true );
								} }
								disabled={ ! settings.id }
							>
								{ __( 'Delete', 'popper' ) }
							</Button>

							<Button
								variant="primary"
								onClick={ () => {
									save( action );
								} }
							>
								{ __( 'Save' ) }
							</Button>
						</HStack>
					</Fragment>
				</VStack>
				<Confirm
					isOpen={ isOpen }
					onConfirm={ () => remove( action ) }
					onCancel={ () => setIsOpen( false ) }
					action={ settings }
				/>
			</Modal>
		</Fragment>
	);
}
